import type { ReactNode } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import { TRADE_TYPE_TO_PREFIX, type TradeTypePrefix } from '@/App/tiles/shared/import/typings.ts';

interface ImportConfirmationModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  tradeTypePrefix: TradeTypePrefix;
}

export function ImportConfirmationModal({
  isOpen,
  onConfirm,
  onCancel,
  tradeTypePrefix,
}: ImportConfirmationModalProps): ReactNode {
  const prefix = TRADE_TYPE_TO_PREFIX[tradeTypePrefix];

  return (
    <Modal show={isOpen} backdrop="static">
      <ModalHeader>
        <FormattedMessage tagName="h4" id={`${prefix}.import.resetModal.title`} />
      </ModalHeader>

      <ModalBody>
        <FormattedMessage id={`${prefix}.import.resetModal.message`} tagName="p" />
      </ModalBody>

      <ModalFooter>
        <button
          type="button"
          className="btn btn-secondary"
          data-e2e="import-confirmation-cancel-button"
          onClick={onCancel}
        >
          <FormattedMessage id="modal.import.cancel" />
        </button>

        <button
          type="button"
          className="btn btn-info"
          data-e2e="import-confirmation-confirm-button"
          onClick={onConfirm}
        >
          <FormattedMessage id="modal.import.confirmModal.confirm" />
        </button>
      </ModalFooter>
    </Modal>
  );
}
